export function sum(arr: Array<number>): number {
  return arr.reduce((total, next: number) => total + next, 0);
}
